var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hotel-nav"},_vm._l((_vm.formattedLinks),function(link){return _c('HotelNavLink',{key:`hotel-menu-${link.text}`,attrs:{"element":link.element,"link":link.link,"text":link.text,"icon":link.icon}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }